export const ConfigClientesInternacionales = {
	barraBusqueda: {
		criterios: ["Razon Social", "Giro", "Identificador"],
		criteriosKeys: ["razonSocial", "giro", "codigoInterno"],
		criterioPrincipal: "Razon Social",
	},
};
